import { Controller } from "@hotwired/stimulus";

// Demo: reflect the tablet's selected location in the placeholder screen, to convey that the
// screen would change per location. No real preview is wired yet.
export default class extends Controller {
  static targets = ["locationField", "screenLocation"];

  connect() {
    this.update();
  }

  // Fired by the location select's bubbling `change` event (wired on the controller root).
  update() {
    if (!this.hasLocationFieldTarget || !this.hasScreenLocationTarget) return;
    const display = this.locationFieldTarget.querySelector('[data-select-target="display"]');
    this.screenLocationTarget.textContent = display ? display.textContent.trim() : "";
  }
}
